import React, { useState } from 'react';
import { ToastContainer } from 'react-toastify';
import { FaPaperclip } from 'react-icons/fa'; 
import 'react-toastify/dist/ReactToastify.css';
import '../style/project.css';
import img1 from "../../src/images/image.png"
import img2 from "../../src/images/osw.png"
import img3 from "../../src/images/codeinsights.jpeg"
import img4 from "../../src/images/77sports.png"
import img5 from "../../src/images/kohira.png"
import img6 from "../../src/images/mcp.svg"

const projectsData = [
  {
    id: 1,
    title: 'CharusatV4',
    description: 'University website Project',
    technology: 'React.js, Next.js, JavaScript, Bootstrap, Tailwind',
    link: 'https://www.charusat.ac.in/',
    image: img1, 
    details: `Modernized university's official website with contemporary design elements and state-of-the-art technologies, enhancing user experience and accessibility.`,
  },
  {
    id: 2,
    title: 'KOHIRA',
    description: 'Jewellery ERP and POS Software',
    technology: 'React.js, Node.js, MySQL, AWS',
    link: 'https://kohira.developmentlabs.co/login',
    image: img5, 
    details: ` A comprehensive ERP and POS software solution designed specifically for the jewellery industry, offering seamless inventory management, sales tracking, and accounting functionalities.`,
  },
  {
    id: 3,
    title: '77 Sports Jamnagar',
    description: 'Sports Equipment E-commerce Website',
    technology: 'React.js, Express.js, MySQL , AWS',
    link: '',
    image: img4, 
    details: 'A one-stop shop for sports equipment, built as a full-stack web store with a React.js storefront, Express.js APIs, and MySQL for product and order data. Deployed on AWS to deliver a fast, reliable shopping experience for customers in Jamnagar.',
  },
  {
    id: 4,
    title: 'Open-Source Weekend',
    description: 'Internship Project',
    technology: 'React.js, Express.js, MongoDB',
    link: 'https://github.com/Nirmalchaudhary/Summer-Internship-1',
    image: img2, 
    details: 'Led the development of Open-Source Weekend, an event management website fostering collaboration within the open-source community.',
  },
  {
    id: 5,
    title: 'Code Insight',
    description: 'Platform for Coding Contests and Coding Profile Summaries',
    technology: 'React.js, Express.js, MongoDB',
    link: 'https://github.com/Jap1959/CodeInsight',
    image: img3, 
    details: 'Code Insights is a comprehensive MERN stack platform designed to host coding contests and provide insightful coding profile summaries.',
  },
  {
    id: 6,
    title: 'AI Agent Data Bridge',
    description: 'MCP Server for PostgreSQL',
    technology: 'Model Context Protocol (MCP), PostgreSQL, Python, REST API',
    link: '',
    image: img6,
    details: 'Built a Model Context Protocol (MCP) server exposing live PostgreSQL data as callable tools, enabling AI agents to query and retrieve real-time database records on demand. Connected the MCP server to a Python API layer for structured, low-latency data access, laying the groundwork for agent-driven database workflows.',
  },
];

const Portfolio = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [selectedProject, setSelectedProject] = useState(null);

  const handlePopupToggle = (project) => {
    setSelectedProject(project);
    setShowPopup(!showPopup);
  };

  return (
    <>

      <section className="projects-section">
        <h2>My Projects 💻</h2>
        <div className="projects-grid">
          {projectsData.map((project) => (
            <div className="project-card" key={project.id}>
              <div className="project-project">
                <img src={project.image} alt={project.title} className="project-image" />
                <div className="project-text">
                  <h3>{project.title}</h3>
                  <p>{project.description}</p>
                  <p>{project.technology}</p>
                  <button className="details-btn" onClick={() => handlePopupToggle(project)}>
                    See More Details
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>


      {selectedProject && (
        <div className={`project-overlay ${showPopup ? 'show' : ''}`} onClick={() => handlePopupToggle(null)}></div>
      )}
      {selectedProject && (
        <div className={`project-popup ${showPopup ? 'show' : ''}`}>
          <button className="close-btn" onClick={() => handlePopupToggle(null)} aria-label="Close project details">
            ×
          </button>

          <div className="popup-project">
            <img src={selectedProject.image} alt={selectedProject.title} className="popup-image" />
            <h3>{selectedProject.title}</h3>
            <p>{selectedProject.technology}</p>
            <p>{selectedProject.details}</p>
            {selectedProject.link && (
              <a href={selectedProject.link} target="_blank" rel="noopener noreferrer">
                <FaPaperclip size={24} />
              </a>
            )}
          </div>
        </div>
      )}

      <ToastContainer />
    </>
  );
};

export default Portfolio;
